import { ApplicationRef, NgModule, Type } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import _get from "lodash/get";

import { AdvancedSearchComponent } from "./entry-modules/advanced-search/advanced-search.component";
import { AdvancedSearchModule } from "./entry-modules/advanced-search/advanced-search.module";
import { SavedSearchesPageComponent } from "./entry-modules/advanced-search/saved-searches/saved-searches-page/saved-searches-page.component";

const entryComponents: Array<Type<unknown>> = [
    AdvancedSearchComponent,
    SavedSearchesPageComponent
];

@NgModule({
    imports: [
        BrowserModule,
        AdvancedSearchModule
    ]
})
export class AppModule {
    public ngDoBootstrap(applicationRef: ApplicationRef): void {
        entryComponents
            .map(component => ({
                component: component,
                nodes: [...document.querySelectorAll(_get<Type<unknown>, string>(component, "SELECTOR"))] as Array<Node>
            }))
            .forEach((relation) => {
                relation.nodes.forEach((node) => {
                    applicationRef.bootstrap(relation.component, node);
                });
            });
    }
}
